import { InputHTMLAttributes } from 'react'

interface SearchIconProps extends InputHTMLAttributes<HTMLInputElement> {}

const SearchIcon: React.FC<SearchIconProps> = ({ ...rest }) => {
  return (
    <div {...rest}>
      <svg
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          opacity='0.3'
          d='M15.4838 18.0994C15.0607 17.6763 15.0607 16.9904 15.4838 16.5673C15.9069 16.1442 16.5928 16.1442 17.0159 16.5673L21.3492 20.9006C21.7723 21.3237 21.7723 22.0096 21.3492 22.4327C20.9261 22.8558 20.2402 22.8558 19.8171 22.4327L15.4838 18.0994Z'
          fill='#F0B323'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.3335 11.9154C4.3335 16.1035 7.72867 19.4987 11.9168 19.4987C16.105 19.4987 19.5002 16.1035 19.5002 11.9154C19.5002 7.72721 16.105 4.33203 11.9168 4.33203C7.72867 4.33203 4.3335 7.72721 4.3335 11.9154ZM17.3333 11.9167C17.3333 14.9082 14.9082 17.3333 11.9167 17.3333C8.92512 17.3333 6.5 14.9082 6.5 11.9167C6.5 8.92512 8.92512 6.5 11.9167 6.5C14.9082 6.5 17.3333 8.92512 17.3333 11.9167Z'
          fill='#F0B323'
        />
      </svg>
    </div>
  )
}

export { SearchIcon }
